import { extractPlainText, sanitizeHtmlContent } from 'types'

const MD_CASE_EMPTY_NOTE_SENTINELS = new Set([
  'Start typing...',
  'Start typing…',
])

export function normalizeMdCaseEditableNoteContent(value: string): string {
  if (!value.trim()) {
    return ''
  }

  const sanitizedValue = sanitizeHtmlContent(value)
  const plainText = extractPlainText(sanitizedValue)
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/…/g, '...')

  if (!plainText || MD_CASE_EMPTY_NOTE_SENTINELS.has(plainText)) {
    return ''
  }

  return value
}
